import axios from "axios";

const HotelApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token dynamically
HotelApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    const csrf = localStorage.getItem("csrfToken");

    // Attach Access Token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    //  Attach CSRF only for state-changing requests
    const method = config.method?.toLowerCase();
    if (csrf && ["post", "put", "patch", "delete"].includes(method)) {
      config.headers["x-csrf-token"] = csrf;
    }

    //  Optional: frontend location (for logging/security)
    if (typeof window !== "undefined") {
      config.headers["x-frontend-location"] = window.location.href;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Common reusable function
export const apiRequest = async (
  method,
  url,
  data = {},
  params = {},
  headers = {},
  signal,
) => {
  try {
    const response = await HotelApi({
      method,
      url,
      data,
      params,
      headers,
      signal,
    });
    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.debug("Request canceled:", error.message);
      return;
    }

    const customError = new Error(
      error.response?.data?.message || error.message,
    );

    customError.success = false;
    customError.status = error.response?.status;
    customError.data = error.response?.data;

    throw customError;
  }
};

// Helper wrappers
export const getData = (url, params = {}, headers = {}, signal) =>
  apiRequest("get", url, {}, params, headers, signal);

export const postData = (url, data = {}, headers = {}, signal) =>
  apiRequest("post", url, data, {}, headers, signal);

export const putData = (url, data = {}, headers = {}, signal) =>
  apiRequest("put", url, data, {}, headers, signal);

export const patchData = (url, data = {}, headers = {}, signal) =>
  apiRequest("patch", url, data, {}, headers, signal);

export const deleteData = (url, params = {}, headers = {}, signal) =>
  apiRequest("delete", url, {}, params, headers, signal);

// Export the original instance
export default HotelApi;
